module.exports = __webpack_public_path__ + "static/awebdesign-569ed711e29fa0d0a0a82c158a2d06a1.png";